import React, { useState, useEffect } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavLink, NavbarToggler } from 'reactstrap';
import { useSecurity } from '../home/Security';
import { UserLogin } from '../user-login/UserLogin';
import { Link } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import './Header.styles.scss';
import { handleError } from '../shared/Functions';
import { DistrictsVService, OperatorsVService } from '../../services/V2/padre';
import { Navigation } from '../home/Navigation';
import { authProvider } from '../../services/Security';
import { removeData, retrieveData, storeData } from '../shared/Functions';
import { LoggedIn } from '../../App';
import logo from '../../logo.png'
import { withToast } from '../shared/Toast';

function Header({ district, setDistrict, isLoggedIn, setIsLoggedIn, operator, setOperator, successToast, errorToast }) {
    const [open, setOpen] = useState<boolean>(false);
    const [operators, setOperators] = useState<any[]>([]);
    const [districts, setDistricts] = useState<any[]>([]);
    const [canReadOperators, setCanReadOperators] = useState<boolean>(false);
    const [canReadDistricts, setCanReadDistricts] = useState<boolean>(false);
    let { authenticationState } = useSecurity();

    useEffect(() => {
        setOperator(retrieveData("Operator"));
        setDistrict(retrieveData("District"));
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(authenticationState === "Authenticated" && canReadOperators){
            OperatorsVService.operatorsVGetAll({
                    pageNumber: 1,
                    orderBy: "Name",
                    orderByDesc: false
                })
                .then((o:any) => setOperators(o.items))
                .catch(err => handleError(err));
        } else if(isLoggedIn === LoggedIn.True && canReadOperators){
            let operatorId = authProvider.getUser().OperatorId;
            OperatorsVService.operatorsVGetAll({
                    pageNumber: 1,
                    orderBy: "Name",
                    orderByDesc: false,
                    filters: [{property:"Id", value:operatorId}]
                })
                .then((o:any) => {
                    setOperator(o.items[0]);
                    storeData("Operator", o.items[0]);
                })
                .catch(err => handleError(err));
        }
    }, [authenticationState, canReadOperators, isLoggedIn])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(operator && canReadDistricts){
            DistrictsVService.districtsVGetAll({
                    pageNumber: 1,
                    orderBy: "Name",
                    orderByDesc: false,
                    filters: [{property:"OperatorId", value:operator.id}]
                })
                .then((d:any) => setDistricts(d.items))
                .catch(err => handleError(err));
        }
    }, [operator, canReadDistricts])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if((authenticationState === "Authenticated" || isLoggedIn === LoggedIn.True)) {
            authProvider.getNexusToken().then(token => {
                let perms = authProvider.getPermissions(token);
                setCanReadOperators(perms.some((perm: string) => perm === "ReadOperator"));
                setCanReadDistricts(perms.some((perm: string) => perm === "ReadDistrict"));
            })
        }
    }, [authenticationState, isLoggedIn])

    const env = process.env.REACT_APP_ENV_NAME?.toLowerCase();

    let toggle = () => setOpen(!open);

    const logoutCallback = () => {
        setDistrict(null);
        setDistricts([]);
        removeData("District");
        setOperator(null);
        setOperators([]);
        removeData("Operator");
    }

    return (
        <header>
            <Navbar className={`navbar navbar-dark navbar-expand-sm ${env === "production" ? "navbar-production" : env === "demo" ? "navbar-demo" : ""}`}>
                {(authenticationState === "Authenticated" || isLoggedIn === LoggedIn.True) &&
                    <Navigation district={district} operator={operator} />
                }
                <Container fluid >
                    <NavbarBrand tag={Link} to="/">
                        <img
                            src={logo}
                            height="50"
                            className="d-inline-block align-middle"
                            alt="React Bootstrap logo"
                            style={{marginRight:"7px"}}
                        />
                        Vigo
                    </NavbarBrand>
                    <NavbarToggler onClick={toggle} className="mr-2" />
                    <Collapse className="d-sm-inline-flex flex-sm-row" isOpen={open} navbar>
                        {authenticationState === "Authenticated" && operators &&
                            <Autocomplete
                                value={operator || {}}
                                id="operator"
                                options={operators}
                                getOptionLabel={(option) => option?.name ?? ""}
                                renderOption={(option, { selected }) => (
                                    <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                )}
                                style={{ width: 250,paddingRight: "10px", color: "#fff" }}
                                renderInput={(params) => <TextField {...params} label="Operator" variant="outlined" />}
                                getOptionSelected={(o, v) => o.id === v.id}
                                onChange={(e, o) => {
                                        if(!operator) {
                                            setDistrict(null);
                                            setDistricts([]);
                                            removeData("District");
                                        }
                                        setOperator(o);
                                        storeData("Operator", o);
                                    }}
                                />
                        }
                        {(authenticationState === "Authenticated" || isLoggedIn === LoggedIn.True) && operator && districts &&
                            <Autocomplete
                                value={district || {}}
                                id="district"
                                options={districts}
                                getOptionLabel={(option) => option?.name ?? ""}
                                renderOption={(option, { selected }) => (
                                    <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                )}
                                style={{ width: 300 }}
                                renderInput={(params) => <TextField {...params} label="District" variant="outlined" />}
                                getOptionSelected={(o, v) => o.id === v.id}
                                onChange={(e, d) => {
                                        setDistrict(d);
                                        storeData("District", d);
                                    }}
                                />
                        }
                    </Collapse>
                    <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={open} navbar>
                        <ul className="navbar-nav flex-grow align-items-center">
                            {env === "production" ?
                                <NavLink className="text-light bold">
                                    PRODUCTION
                                </NavLink> :
                            env === "demo" ?
                                <NavLink className="text-light bold">
                                    DEMO
                                </NavLink> :
                                <NavLink className="text-light bold">
                                    TEST
                                </NavLink>}
                            <React.Fragment>
                                <UserLogin isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} logoutCallback={logoutCallback} successToast={successToast} errorToast={errorToast} />
                            </React.Fragment>
                        </ul>
                    </Collapse>
                </Container>
            </Navbar>
        </header>
    );
}
export default withToast(Header as any);